import React from 'react'
import ProfileSection from '../DashSubComponents/ProfileSection'
import SuggestedGroup from '../DashSubComponents/SuggestedGroup'
import Footer from '../DashSubComponents/Footer'
import DashBarProgress from '../DashSubComponents/DashBarProgress'
import YourGroups from '../DashSubComponents/YourGroups'
const PageLayout = ({ children }) => {
  return (
    <main>
      <div className="main-section">
        <div className="container">
          <div className="main-section-data">
            <div className="row">

              {/* LEFT */}
              <div className="col-lg-3 col-md-4 pd-left-none no-pd">
                <div className="main-left-sidebar no-margin">
                  <ProfileSection/>
                  {/* <SuggestedGroup /> */}
                  <Footer/>
                </div>
              </div>

              {/* MIDDLE */}
              <div className="col-lg-6 col-md-8 no-pd">
                <div className="main-ws-sec p-3">
                  {children}
                </div>
              </div>

              {/* RIGHT */}
              <div className="col-lg-3 pd-right-none no-pd">
                <div className="right-sidebar">
                  <div className="card mb-3 p-2 text-center">
                    <DashBarProgress/>
                  </div>
                  <YourGroups />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default PageLayout